import type { FaqItem } from "@/components/feature/FaqAccordion";
import type { FarmerProfile } from "@/mocks/farmerProfiles";

/**
 * Builds a tailored set of visitor FAQs for a single farmer using their real
 * data, so every farmer detail page gets relevant questions and answers.
 */
export const buildFarmerFaqs = (farmer: FarmerProfile): FaqItem[] => [
  {
    q: `Can I meet ${farmer.name} in person?`,
    a: `Yes. ${farmer.name} personally hosts visitors on the farm in ${farmer.village} through our ${farmer.experienceLabel} experience. You will spend time together in the fields, hear their story first-hand and join the everyday work of the farm.`,
  },
  {
    q: `What is ${farmer.name} best known for?`,
    a: `${farmer.name} is known for ${farmer.specialties.join(", ")}. With ${farmer.farmingFor.toLowerCase()}, they have a deep, practical understanding of growing ${farmer.crop.toLowerCase()} in the Konaseema delta.`,
  },
  {
    q: `Where does ${farmer.name} farm?`,
    a: `${farmer.name} farms in ${farmer.village}, in the Godavari delta of Konaseema, Andhra Pradesh. We share an exact location and route once your visit is confirmed.`,
  },
  {
    q: `What experience can I join with ${farmer.name}?`,
    a: `The ${farmer.experienceLabel} is hosted right here and led by ${farmer.name}. It is a real, working visit — not a performance — so you see the farm exactly as it is on the day you arrive.`,
  },
  {
    q: `Is a visit suitable for families and children?`,
    a: `Yes. Families and children are very welcome. ${farmer.name} enjoys introducing young visitors to the land, and the activities are adjusted so everyone can take part comfortably.`,
  },
  {
    q: `Do I need to book in advance?`,
    a: `We recommend booking at least 3–5 days ahead so ${farmer.name} can plan around the season and the farm's work. During the cooler months from October to February, dates fill up faster.`,
  },
];